/** 访问页面统计 table */
import React from 'react';
import {Table} from 'antd';

class ComTable extends React.Component{
  state = {
    scrollY: 560
  };
  toPage(path) {
    const {statisticsType, dateTimeVal, startDate, endDate} = this.props.filterData;
    const params = {
      url: path,
      statisticsType,
      dateTimeVal,
      startDate,
      endDate
    };
    sessionStorage.setItem('filterData', JSON.stringify(params));
    this.props.history.push(`/apm/home/interfaceDetails?url=${path}`);
  };
  columns = [
    {
      title: 'URL',
      dataIndex: 'path',
      render: (val, row, index) => (
        <span className="c-primary cursor" onClick={() => this.toPage(row.path)}>{row.path}</span>
      ),
    }, {
      title: '调用次数',
      dataIndex: 'requestTimes',
      width: 90,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '页面加载时间',
      dataIndex: 'pageLoadTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.pageLoadTime} ms</span>
      )
    }, {
      title: '白屏时间',
      dataIndex: 'firstPaintTime',
      width: 90,
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.firstPaintTime} ms</span>
      )
    }, {
      title: '资源加载耗时',
      dataIndex: 'requestTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.requestTime} ms</span>
      )
    }, {
      title: 'DOM构建耗时',
      dataIndex: 'domCompleteTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.domCompleteTime} ms</span>
      )
    }, {
      title: 'DOM解析耗时',
      dataIndex: 'domAnalysisTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.domAnalysisTime} ms</span>
      )
    }, {
      title: 'DNS解析耗时',
      dataIndex: 'dnsTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.dnsTime} ms</span>
      )
    }, {
      title: 'TCP连接耗时',
      dataIndex: 'tcpTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.tcpTime} ms</span>
      )
    },
  ];
  UNSAFE_componentWillMount() {
    this.setState({
      scrollY: document.documentElement.clientHeight - 350
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 350
      })
    }
  };
  render() {
    const { tbData, pagination, loading } = this.props;
    const { scrollY } = this.state;
    return (
      <Table scroll={{x: 1000, y: scrollY}} bordered loading={loading} pagination={pagination} rowKey={(record, index) => index}
        columns={this.columns} dataSource={tbData} onChange={this.props.pageChange} />
    );
  }
};
export default ComTable;
